
import React, { useRef, useState } from "react";
import axios from "axios";
const qs = require('querystring');   //Add new npm

const removeNullFromArray = (arrayToClean) => {
    const cleanedArray = [];
    arrayToClean.forEach((val) => {
        if (val !== null) {
            cleanedArray.push(val);
        }
    });

    return cleanedArray;
}

function DeleteResource(props) {

    let [loading, setLoading] = useState(false);

    console.log(props)
   
  /*  const  onSubmit = (e) => {
        setLoading({ loading: true });
        const dataToSend = {
            index: props.indexName,
            id:props.ElasticID,
          };
          // Make the POST request
          axios.post('https://fs3.acl.gov/deleteRecord', dataToSend)
        // axios.post('http://localhost:3001/deleteRecord', dataToSend)
           .then((response) => {
              // Handle the response when successful
              console.log('Update successful:', response.data);
              
              // Optionally reload the page after 3 seconds
               setTimeout(() => {
                window.location.reload();
              }, 20000);  // Wait 3 seconds before reloading
            }) 
            .finally(() => {
               //Stop the loading state
              setLoading({ loading: false });
           });
         

     

    }; */
    const onSubmit = (e) => {
        e.preventDefault(); // Prevent default form submission behavior
        setLoading(true); // Set loading to true
    
        const dataToSend = {
            index: props.indexName,
            id: props.ElasticID,
            archiveIndex: props.indexNameArchive
        };
    
        axios.post('https://fs3.acl.gov/archiveRecord', dataToSend) 
            .then((response) => {
            // Handle the response when successful
              console.log('Archive successful:', response.data);
             }
            )

        .then(
        axios.post('https://fs3.acl.gov/deleteRecord', dataToSend)
            .then((response) => {
                // Handle the response when successful
                console.log('Delete successful:', response.data); 
                
                // Optionally reload the page after 2 seconds
                setTimeout(function () {
                    e.preventDefault();
                    window.location.reload();
                }, 3000)
            }))
    };

   console.log("props:", props)
        return (

            <div>
                <div class="row body_content">

                    <div class="row" style={{ width: 100 + "%" }}>
                        <div class="post-content" style={{ width: 90 + "%" }}>
                            <p class="text-lg">Are you sure you want permanently remove this resource?</p>

                            <form onSubmit={onSubmit}
                            >
                                <div grid grid-cols-6 gap-6>

                                    <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                        <button
                                            disabled={loading}
                                            type="submit"
                                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                        >
                                            {loading && (
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />
                                            )}
                                            {loading && <span>Processing Request</span>}
                                            {!loading && <span>Delete</span>}

                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>
                </div >

            </div>

        );
    }




export default DeleteResource;

